import React from "react";
import { colors, spacing, typography } from "../utils/designTokens";

/**
 * Campo de formulario con label accesible y error display.
 *
 * Props:
 * - label (string): texto del label
 * - htmlFor (string): id del input asociado
 * - required (boolean, opcional): muestra asterisco
 * - error (string, opcional): mensaje de error
 * - hint (string, opcional): texto de ayuda debajo del input
 * - children: el input/select/textarea
 * - fullWidth (boolean, opcional): ocupa ancho completo en grid
 */
const FormField = ({ label, htmlFor, required, error, hint, children, fullWidth, style: customStyle }) => {
  return (
    <div
      style={{
        ...styles.container,
        ...(fullWidth ? { gridColumn: "1 / -1" } : {}),
        ...customStyle,
      }}
    >
      {label && (
        <label htmlFor={htmlFor} style={styles.label}>
          {label}
          {required && <span style={styles.required}> *</span>}
        </label>
      )}
      {children}
      {error && (
        <span style={styles.error} role="alert">
          {error}
        </span>
      )}
      {hint && !error && <span style={styles.hint}>{hint}</span>}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: spacing[1],
  },
  label: {
    fontSize: typography.sizes.base,
    fontWeight: 400,
    color: colors.gray900,
    lineHeight: 1.4,
  },
  required: {
    color: colors.error,
  },
  error: {
    fontSize: typography.sizes.sm,
    color: colors.error,
    lineHeight: 1.3,
  },
  hint: {
    fontSize: typography.sizes.sm,
    color: colors.gray400,
    lineHeight: 1.3,
  },
};

export default FormField;
